<div class="loading-overlay" *ngIf="isDataLoading; else content">
  <mat-spinner></mat-spinner>
</div>

<ng-template #content>
  <div *ngIf="!isEmpty && filters && filterPredicate" class="dynamic-list-filters">
    <div class="dynamic-list-filters__wrapper" [formGroup]="filtersControlsGroup">
      <ng-container *ngFor="let filter of allFilters">
        <mat-form-field appearance="outline" floatLabel="never" *ngIf="filter.type === DynamicListFilterType.TEXT; else filterTextElse">
          <mat-label>{{ filter.label }}</mat-label>
          <input matInput type="text" [formControlName]="filter.formKey" />
          <mat-icon matSuffix class="pointer" (click)="clearFilter(filter.formKey)">close</mat-icon>
        </mat-form-field>

        <ng-template #filterTextElse>
          <mat-form-field appearance="outline" floatLabel="never">
            <mat-label>{{ !getFilterControl(filter.formKey)?.value ? filter.anyLabel || '-' : filter.label }}</mat-label>
            <mat-select [formControlName]="filter.key" [multiple]="filter.multiple">
              <mat-option *ngFor="let option of filter.options" [value]="option.value">{{ option.text }}</mat-option>
            </mat-select>
            <mat-icon matSuffix class="pointer" (click)="clearFilter(filter.formKey)">close</mat-icon>
          </mat-form-field>
        </ng-template>
      </ng-container>
    </div>
  </div>

  <div class="add-button-container" *ngIf="canAddItem && !isEmpty">
    <button class="list-add-button" mat-flat-button color="primary" (click)="addCallback()">{{ addLabel }} <mat-icon>add</mat-icon></button>
  </div>

  <mat-expansion-panel
    (opened)="selectionPanelOpened(true)"
    (closed)="selectionPanelOpened(false)"
    *ngIf="!isEmpty && selectionActions?.length"
  >
    <mat-expansion-panel-header>
      <mat-panel-title> Opções de selecção </mat-panel-title>
      <mat-panel-description *ngIf="!hasFilters"> Total de {{ dataSource.filteredData.length }} items</mat-panel-description>
      <mat-panel-description *ngIf="hasFilters"> Resultados da filtragem: {{ dataSource.filteredData.length }} items {{ hasFilters ? '(' + dataSource.data.length +  ' total)' : '' }}</mat-panel-description>
    </mat-expansion-panel-header>

    <mat-panel-title>
      <button
        *ngIf="selectionActions?.length"
        mat-button
        [matMenuTriggerFor]="selectedItemsMenu"
        class="selected-persons-options-btn"
        [disabled]="!selectedOptionsCount"
      >
        <mat-icon aria-hidden="false" aria-label="{{ item.title }">menu</mat-icon>
      </button>

      <mat-menu #selectedItemsMenu="matMenu" class="popup-menu" backdropClass="menu-popup-backdrop">
        <label>Com os seleccionados:</label>

        <button *ngFor="let action of selectionActions" mat-menu-item (click)="selectionActionClicked(action)">{{ action.label }}</button>
      </mat-menu>

      <span>{{ selectedOptionsCount }} items seleccionados </span>
    </mat-panel-title>
  </mat-expansion-panel>

  <div class="placeholder-container" *ngIf="isFilteredEmpty">
    <cm-empty-list-placeholder
      [canAdd]="canAddItem && isEmpty"
      [addNeededScopes]="addNeededScopes"
      [addLabel]="addLabel || 'Adicionar'"
      (add)="addCallback()"
      [placeholder]="placeholder"
    ></cm-empty-list-placeholder>
  </div>

  <cdk-virtual-scroll-viewport tvsItemSize="48" headerHeight="42" #virtualScroll *ngIf="!isFilteredEmpty">
    <table mat-table [dataSource]="dataSource">
      <ng-container *ngFor="let column of columns; index as i" [matColumnDef]="column['key']">
        <th mat-header-cell *matHeaderCellDef>{{ column.title }}</th>
        <td mat-cell *matCellDef="let item; let j = index">
          <ng-container *ngIf="column.template; else defaultColumRendering">
            <ng-template
              *ngTemplateOutlet="column.template; context: { $implicit: item.data, index: dataSource.data.indexOf(item) }"
            ></ng-template>
          </ng-container>

          <ng-template #defaultColumRendering>{{ getColumnValue(item, column.key) }}</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="checkboxes">
        <th mat-header-cell *matHeaderCellDef>
          <mat-checkbox [formControl]="allControl"></mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let item; let j = index" (click)="clickedCheckboxBorder($event, item)">
          <mat-checkbox [checked]="item.selected" (change)="itemSelectionToggled()"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let item; let j = index">
          <button
            mat-icon-button
            [matMenuTriggerFor]="actionsMenu"
            aria-label="Item actions menu"
            (click)="openContextMenu($event, item, actionsMenu)"
          >
            <mat-icon>more_vert</mat-icon>
          </button>

          <mat-menu #actionsMenu="matMenu">
            <button
              *ngFor="let action of actions"
              mat-menu-item
              (click)="actionClicked($event, action, item)"
              [disabled]="actionDisabled(action, item)"
            >
              <mat-icon *ngIf="action.icon">{{ action.icon }}</mat-icon>
              <span>{{ action.label }}</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumnKeys"></tr>
      <tr mat-row *matRowDef="let item; columns: displayedColumnKeys" [ngClass]="getRowClass(item)" (click)="rowClicked($event, item)"></tr>
    </table>
  </cdk-virtual-scroll-viewport>
</ng-template>
